import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.News.Details.Messages';

export default defineMessages({
  MostReadNews: {
    id: `${scope}.mostReadNews`,
    defaultMessage: 'Najčitanije',
  },
  AllNewsFromThisCategory: {
    id: `${scope}.allNewsFromThisCategory`,
    defaultMessage: 'Prikaži sve objave iz ove kategorije',
  },
  NewsPublished: {
    id: `${scope}.newsPublished`,
    defaultMessage: 'Datum objave',
  },
  NewsPublish: {
    id: `${scope}.newsPublish`,
    defaultMessage: 'Vest objavljuje',
  },
  NewsCategory: {
    id: `${scope}.newsCategory`,
    defaultMessage: 'Kategorija objave',
  },
  ShareNews: {
    id: `${scope}.shareNews`,
    defaultMessage: 'Podeli objavu',
  },
  AdForJob: {
    id: `${scope}.adForJob`,
    defaultMessage: 'Tražite radnike? Želite da postavite oglas za posao?',
  },
  ClickHere: {
    id: `${scope}.clickHere`,
    defaultMessage: 'Kliknite OVDE',
  },
  NoSimilarNews: {
    id: `${scope}.noSimilarNews`,
    defaultMessage: 'Nema sličnih objava',
  },
  News: {
    id: `${scope}.news`,
    defaultMessage: 'Vesti',
  },
});
